// import { ViewAll } from '../../common/viewAll';

export const LearnMutualFund = ({ SECTION_LEARN_MORE }) => (
  <div id="learn-to-invest" className="lil-container lil-mt-16 sm:lil-mt-12">
    <div className="lil-flex lil-items-center sm:lil-flex-col">
      <div className="lil-w-1/2 sm:lil-w-full ">
        <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32">
          Learn about mutual funds
        </h2>
        <p>
          Explore and learn about mutual funds from multiple well curated
          articles.
        </p>
        {/* <ViewAll
          title="View all topics"
          link="https://cleartax.in/s/mutual-funds"
          classes="lil-mt-10 sm:lil-hidden"
        /> */}
      </div>
      <div className="lil-w-1/2 sm:lil-w-full">
        <div className="lil-flex lil-flex-wrap lil-pt-6 lil-items-center sm:lil-items-start">
          {SECTION_LEARN_MORE.cards.map((ele, index) => {
            return (
              <div
                className={`sm:lil-h-32  lil-h-40  lil-pr-4 lil-mb-4 lil-w-1/2 lil-cursor-pointer `}
                key={index}
              >
                <a href={`${ele.link}`} className="hover:lil-no-underline">
                  <div className="lg:lil-p-4 lil-flex-col lil-h-full lil-items-center lil-px-4 lil-py-4 lil-py-6 lil-relative lil-rounded-xl lil-shadow-sm">
                    <h6>{ele.title}</h6>
                    <div
                      className="lil-absolute lil-flex lil-justify-end"
                      style={{ right: 15, bottom: 15 }}
                    >
                      <img
                        src={ele.icon}
                        alt={ele.title}
                        height="35px"
                        width="35px"
                      />
                    </div>
                  </div>
                </a>
              </div>
            );
          })}
        </div>
      </div>
      {/* <ViewAll
        title="View all topics"
        link="https://cleartax.in/s/mutual-funds"
        classes="lil-mt-10 xl:lil-hidden lg:lil-hidden md:lil-hidden"
      /> */}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/learnMutualFunds/learnMutualFunds.tsx